import _defineProperty from "/home/keoadmin/agent/_work/61/s/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { encodeQueryParams } from "serialize-query-params";
import { decodedParamCache } from "./decodedParamCache";
import { extendParamConfigForKeys } from "./inheritedParams";
import { getLatestDecodedValues } from "./latestValues";
import { memoSearchStringToObject } from "./memoSearchStringToObject";
import { removeDefaults } from "./removeDefaults";
import { applyUrlNames } from "./urlName";
function getUpdatedSearchString(_ref) {
  var changes = _ref.changes,
    updateType = _ref.updateType,
    currentSearchString = _ref.currentSearchString,
    baseParamConfigMap = _ref.paramConfigMap,
    options = _ref.options;
  var searchStringToObject = options.searchStringToObject,
    objectToSearchString = options.objectToSearchString;
  if (updateType == null) updateType = options.updateType;
  var encodedChanges;
  var parsedParams = memoSearchStringToObject(searchStringToObject, currentSearchString);
  var paramConfigMap = extendParamConfigForKeys(baseParamConfigMap, Object.keys(changes), options.params);
  var changesToUse;
  if (typeof changes === "function") {
    var latestValues = getLatestDecodedValues(parsedParams, paramConfigMap, decodedParamCache);
    changesToUse = changes(latestValues);
  } else {
    changesToUse = changes;
  }
  encodedChanges = encodeQueryParams(paramConfigMap, changesToUse);
  if (options.removeDefaultsFromUrl) {
    removeDefaults(encodedChanges, paramConfigMap);
  }
  encodedChanges = applyUrlNames(encodedChanges, paramConfigMap);
  var newSearchString;
  if (updateType === "push" || updateType === "replace") {
    newSearchString = objectToSearchString(encodedChanges);
  } else {
    newSearchString = objectToSearchString(_objectSpread(_objectSpread({}, parsedParams), encodedChanges));
  }
  if ((newSearchString == null ? void 0 : newSearchString.length) && newSearchString[0] !== "?") {
    newSearchString = "?".concat(newSearchString);
  }
  return newSearchString != null ? newSearchString : "";
}
function updateSearchString(_ref2) {
  var searchString = _ref2.searchString,
    adapter = _ref2.adapter,
    navigate = _ref2.navigate,
    updateType = _ref2.updateType;
  var currentLocation = adapter.location;
  var newLocation = _objectSpread(_objectSpread({}, currentLocation), {}, {
    search: searchString
  });
  if (navigate) {
    if (typeof updateType === "string" && updateType.startsWith("replace")) {
      adapter.replace(newLocation);
    } else {
      adapter.push(newLocation);
    }
  }
}
var immediateTask = function immediateTask(task) {
  return task();
};
var timeoutTask = function timeoutTask(task) {
  return setTimeout(function () {
    return task();
  }, 0);
};
var updateQueue = [];
function enqueueUpdate(args) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    immediate = _ref3.immediate;
  updateQueue.push(args);
  var scheduleTask = immediate ? immediateTask : timeoutTask;
  if (updateQueue.length === 1) {
    scheduleTask(function () {
      var updates = updateQueue.slice();
      updateQueue.length = 0;
      var initialSearchString = updates[0].currentSearchString;
      var searchString;
      for (var i = 0; i < updates.length; ++i) {
        var modifiedUpdate = i === 0 ? updates[i] : _objectSpread(_objectSpread({}, updates[i]), {}, {
          currentSearchString: searchString
        });
        searchString = getUpdatedSearchString(modifiedUpdate);
      }
      if (args.options.skipUpdateWhenNoChange && searchString === initialSearchString) {
        return;
      }
      updateSearchString({
        searchString: searchString != null ? searchString : "",
        adapter: updates[updates.length - 1].adapter,
        navigate: true,
        updateType: updates[updates.length - 1].updateType
      });
    });
  }
}
export { enqueueUpdate, getUpdatedSearchString, updateSearchString };